import React from 'react';
import ContainerLayout from '../../layouts/ContainerLayout';

export default function OfficialRidesharePartner() {
  return (
    <ContainerLayout>
      <h4 className="text-center mt-3 mb-4">Official Rideshare Partner</h4>

      <div className="row">
        <div className="col-12 d-flex justify-content-center align-items-center">
          {/* 875x840 */}
          <img src="/images/hornets.png" alt="" width="175" height="168" className="mb-2" />
        </div>
      </div>
    </ContainerLayout>
  );
}
